export default function getRole(role) {
  const roles = {
    parent: "Родитель",
    student: "Ученик",
    teacher: "Учитель",
  };
  return roles[role];
}



// WEBPACK FOOTER //
// ./app/frontend/components/getRole.js